import { LocalizationService } from 'src/app/service/localization.service';
import { JsonKey } from 'src/app/data/type/locale-copy-key';

interface ChromecastFeature {
  title: string;
  images?: Array<{ src: string; alt: string }>;
  copy?: string;
  isButton?: boolean;
  hasCheckMark?: boolean;
}

interface ChromecastType {
  title: string;
  features: Array<ChromecastFeature>;
}

export interface ChromecastTypes {
  fourK: ChromecastType;
  hd: ChromecastType;
}

export const getChromecastTypes = (localizationService: LocalizationService): ChromecastTypes => {
  return {
    fourK: {
      title: localizationService.translate(JsonKey.SPECS_4K_TITLE),
      features: [
        {
          title: localizationService.translate(JsonKey.SPECS_4K_COLOR_TITLE),
          images: [
            {
              src: '/assets/images/compare/grey-elipse.png',
              alt: 'Grey Eclipse',
            },
            {
              src: '/assets/images/compare/light-red-elipse.png',
              alt: 'Light Red Eclipse',
            },
            {
              src: '/assets/images/compare/dark-grey-elipse.png',
              alt: 'Dark Grey Eclipse',
            },
          ],
        },
        {
          title: localizationService.translate(JsonKey.SPECS_4K_VIDEO_RESOLUTION_TITLE),
          copy: localizationService.translate(JsonKey.SPECS_4K_VIDEO_RESOLUTION_BODY),
          isButton: true,
          images: [
            {
              src: '/assets/images/compare/4k.png',
              alt: '4k Logo',
            },
          ],
        },
        {
          title: localizationService.translate(JsonKey.SPECS_4K_VOICE_REMOTE_TITLE),
          hasCheckMark: true,
        },
        {
          title: localizationService.translate(JsonKey.SPECS_4K_WITH_GOOGLE_TV_TITLE),
          copy: localizationService.translate(JsonKey.SPECS_4K_WITH_GOOGLE_TV_BODY_LINE_1),
          hasCheckMark: true,
        },
        {
          title: localizationService.translate(JsonKey.SPECS_4K_WORKS_WITH_APPS_TITLE),
          hasCheckMark: true,
        },
        {
          title: localizationService.translate(JsonKey.SPECS_4K_NEST_SPEAKERS_TITLE),
          hasCheckMark: true,
        },
        {
          title: localizationService.translate(JsonKey.SPECS_4K_CONTROL_DEVICES_TITLE),
          isButton: true,
          hasCheckMark: true,
        },
        {
          title: localizationService.translate(JsonKey.SPECS_4K_CAST_TITLE),
          hasCheckMark: true,
        },
        {
          title: localizationService.translate(JsonKey.SPECS_4K_STADIA_COMPATIBLE_TITLE),
          hasCheckMark: true,
        },
        {
          title: localizationService.translate(JsonKey.SPECS_4K_DIMENSIONS_WEIGHT_TITLE),
          copy: localizationService.translate(JsonKey.SPECS_4K_DIMENSIONS_WEIGHT_BODY_LINE_1),
        },
        {
          title: localizationService.translate(JsonKey.SPECS_4K_CONNECTIVITY_TITLE),
          copy: localizationService.translate(JsonKey.SPECS_4K_CONNECTIVITY_BODY_LINE_1),
        },
        {
          title: localizationService.translate(JsonKey.SPECS_4K_VIDEO_FORMATS_TITLE),
          copy: localizationService.translate(JsonKey.SPECS_4K_VIDEO_FORMATS_BODY),
        },
        {
          title: localizationService.translate(JsonKey.SPECS_4K_PORTS_TITLE),
          copy: localizationService.translate(JsonKey.SPECS_4K_PORTS_BODY_LINE_1),
        },
      ],
    },
    hd: {
      title: localizationService.translate(JsonKey.SEPCS_HD_TITLE),
      features: [
        {
          title: localizationService.translate(JsonKey.SPECS_HD_COLORS_TITLE),
          images: [
            {
              src: '/assets/images/compare/grey-elipse.png',
              alt: 'Grey Eclipse',
            },
          ],
        },
        {
          title: localizationService.translate(JsonKey.SPECS_HD_VIDEO_RESOLUTION_TITLE),
          copy: localizationService.translate(JsonKey.SPECS_HD_VIDEO_RESOLUTION_BODY),
          isButton: true,
          images: [
            {
              src: '/assets/images/compare/hd.png',
              alt: 'HD Logo',
            },
          ],
        },
        {
          title: localizationService.translate(JsonKey.SPECS_HD_VOICE_REMOTE_TITLE),
          hasCheckMark: true,
        },
        {
          title: localizationService.translate(JsonKey.SPECS_HD_WITH_GOOGLE_TV_TITLE),
          copy: localizationService.translate(JsonKey.SPECS_HD_WITH_GOOGLE_TV_BODY_LINE_1),
          hasCheckMark: true,
        },
        {
          title: localizationService.translate(JsonKey.SPECS_HD_WORKS_WITH_APPS_TITLE),
          hasCheckMark: true,
        },
        {
          title: localizationService.translate(JsonKey.SPECS_HD_NEST_SPEAKERS_TITLE),
          hasCheckMark: true,
        },
        {
          title: localizationService.translate(JsonKey.SPECS_HD_CONTROL_DEVICES_TITLE),
          isButton: true,
          hasCheckMark: true,
        },
        {
          title: localizationService.translate(JsonKey.SPECS_HD_CAST_TITLE),
          hasCheckMark: true,
        },
        {
          title: localizationService.translate(JsonKey.SPECS_HD_STADIA_COMPATIBLE_TITLE),
          hasCheckMark: true,
        },
        {
          title: localizationService.translate(JsonKey.SPECS_HD_DIMENSIONS_WEIGHT_TITLE),
          copy: localizationService.translate(JsonKey.SPECS_HD_DIMENSIONS_WEIGHT_BODY_LINE_1),
        },
        {
          title: localizationService.translate(JsonKey.SPECS_HD_CONNECTIVITY_TITLE),
          copy: localizationService.translate(JsonKey.SPECS_HD_CONNECTIVITY_BODY_LINE_1),
        },
        {
          title: localizationService.translate(JsonKey.SPECS_HD_VIDEO_FORMATS_TITLE),
          copy: localizationService.translate(JsonKey.SPECS_HD_VIDEO_FORMATS_BODY),
        },
        {
          title: localizationService.translate(JsonKey.SPECS_HD_PORTS_TITLE),
          copy: localizationService.translate(JsonKey.SPECS_HD_PORTS_BODY_LINE_1),
        },
      ],
    },
  };
};
